/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import classNames from 'classnames';
import { Badge as AntdBadge } from 'antd';
import { ConfigContext } from '../config-provider';
import Ribbon from './Ribbon';
import { Icon } from '../icon';
import { PresetColorTypes, PresetStatusColorTypes } from '../_util/colors';
const Badge = (props) => {
    const { prefixCls, scrollNumberPrefixCls, className, dot, overflowDot, showStatusIcon, count, overflowCount, color } = props;
    const { size, status, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('badge', prefixCls);
    const classScrollNumberPrefixCls = getPrefixCls('scroll-number', scrollNumberPrefixCls);
    let newCount = count;
    let newDot = dot;
    let newShowIcon = showStatusIcon;
    const PresetStatusColorRegex = new RegExp(`^(${PresetStatusColorTypes.join('|')})$`);
    const PresetColorRegex = new RegExp(`^(${PresetColorTypes.join('|')})(-inverse)?$`);
    let badgeColor = !color ? '' : color.toLocaleLowerCase().replace(/\s/g, '-');
    const isPresetColor = () => {
        if (!color) {
            return false;
        }
        return PresetColorRegex.test(badgeColor) || PresetStatusColorRegex.test(badgeColor);
    };
    // 1.默认显示为圆点，dot=true
    // 2.count存在时dot为false
    // 3.在xs尺寸下一律为圆点，状态图标不显示，dot=true
    if (typeof count !== 'undefined') {
        newDot = false;
    }
    if (size === 'xs' || size === 'xxs') {
        newDot = true;
        newShowIcon = false;
    }
    //当count大于封顶数值且overflowDot=true时显示 ···
    if (count && overflowCount && count > overflowCount && overflowDot) {
        newCount = '···';
    }
    if (status && newShowIcon) {
        switch (status) {
            case 'warning':
                newCount = React.createElement(Icon, { type: 'time--filled' });
                break;
            case 'success':
                newCount = React.createElement(Icon, { type: 'checkmark--filled' });
                break;
            case 'danger':
                newCount = React.createElement(Icon, { type: 'warning--filled' });
                break;
            case 'error':
                //@ts-ignore
                newCount = React.createElement(Icon, { type: 'error--filled' });
                break;
            case 'information':
                newCount = React.createElement(Icon, { type: 'information--filled' });
                break;
        }
    }
    const newClassName = classNames({
        [`${classPrefix}-xxs`]: size === 'xxs',
        [`${classPrefix}-xs`]: size === 'xs',
        [`${classPrefix}-sm`]: size === 'small',
        [`${classPrefix}-success`]: status === 'success',
        [`${classPrefix}-warning`]: status === 'warning',
        [`${classPrefix}-error`]: status === 'error',
        [`${classPrefix}-information`]: status === 'information',
        [`${classPrefix}-danger`]: status === 'danger',
        [`${classPrefix}-${badgeColor}`]: isPresetColor()
    }, className);
    let finalStatus;
    if (status === 'danger') {
        finalStatus = 'error';
    }
    else if (status === 'information') {
        finalStatus = 'Processing';
    }
    else {
        finalStatus = status;
    }
    let statusProps = finalStatus && newShowIcon ? {} : { status: finalStatus };
    //处理xxs size
    if (size !== 'xs' && size !== 'xxs') {
        return (React.createElement(AntdBadge, { ...otherProps, prefixCls: classPrefix, scrollNumberPrefixCls: classScrollNumberPrefixCls, ...statusProps, className: newClassName, size: size, dot: newDot, count: newCount }));
    }
    return (React.createElement(AntdBadge, { ...otherProps, prefixCls: classPrefix, scrollNumberPrefixCls: classScrollNumberPrefixCls, ...statusProps, className: newClassName, dot: newDot, count: newCount }));
};
const BadgeDefaultProps = AntdBadge.defaultProps;
Badge.defaultProps = {
    ...BadgeDefaultProps,
    status: undefined,
    size: 'default',
    dot: true,
    overflowDot: false,
    showStatusIcon: false
};
Badge.Ribbon = Ribbon;
// const ConfiguredBadge = withConfigProvider(Badge);
// export { ConfiguredBadge as Badge };
// export default ConfiguredBadge;
export { Badge };
export default Badge;
